module.exports = __webpack_public_path__ + "images/invader1.png";